export interface BlogAuthor {
  name: string;
  role: string;
  avatar: string;
}

export interface BlogPost {
  id: string;
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  content: string;
  author: BlogAuthor;
  publishedAt: string;
  readTime: number;
  coverImage: string;
  tags: string[];
  featured?: boolean;
}

export const blogAuthors: Record<string, BlogAuthor> = {
  jeong: {
    name: "정은현",
    role: "Co-Founder & 아르트레너 디렉터",
    avatar: "https://storage.readdy-site.link/project_files/362f3206-c32d-4165-9763-523bbd9d0cd3/19b837b4-5096-43d8-b318-4dd3a116ce51_-2026-03-19-221608.png?v=d692200ed230837e554bc42b34c76800",
  },
  song: {
    name: "송원영",
    role: "Co-Founder & 비즈니스 전략가",
    avatar: "https://storage.readdy-site.link/project_files/362f3206-c32d-4165-9763-523bbd9d0cd3/b3b4cd0a-47d4-4238-a67f-41ff37eb1e8a_-2026-03-22-202437.png?v=55ed0c3f34d36f1f7a235ea25544d94f",
  },
};

export const blogPosts: BlogPost[] = [
  {
    id: "1",
    slug: "artist-to-ceo-5-steps",
    category: "비즈니스 전략",
    featured: true,
    title: "아티스트가 CEO가 되는 5단계 전략",
    excerpt: "재능은 있지만 어디서 시작해야 할지 모르는 아티스트를 위한 실전 로드맵. 아르트레너 파트너 200명의 데이터에서 추출한 공통 성공 패턴을 공개합니다.",
    coverImage: "https://public.readdy.ai/ai/img_res/06b265cc04992e20309cc582b1d203de.jpg",
    author: blogAuthors.jeong,
    publishedAt: "2026-03-15",
    readTime: 8,
    tags: ["창업", "아티스트", "비즈니스 전략", "IP"],
    content: `
<h2>왜 대부분의 아티스트는 비즈니스에서 실패하는가</h2>
<p>한국에는 매년 수만 명의 예술대 졸업생이 쏟아집니다. 그 중 5년 후에도 창작 활동으로 생계를 유지하는 비율은 채 3%가 되지 않습니다. 재능이 없어서가 아닙니다. <strong>비즈니스 구조를 몰라서</strong>입니다.</p>
<p>아르트레너는 지난 3년간 200명 이상의 아티스트와 함께 비즈니스를 만들었습니다. 그 과정에서 성공한 아티스트들에게는 뚜렷한 공통점이 있었습니다. 오늘은 그 패턴을 5단계로 정리해 공유합니다.</p>

<h2>1단계: IP 자산화 — 당신의 창작물을 '소유'하라</h2>
<p>가장 먼저 해야 할 일은 내 창작물이 무엇인지 명확히 하고, 그것을 법적으로 보호하는 것입니다. 놀랍게도 많은 아티스트들이 자신의 작품에 대한 저작권 등록조차 하지 않은 채 활동합니다.</p>
<p>IP 자산화의 3가지 핵심은 다음과 같습니다:</p>
<ul>
<li><strong>저작권 등록</strong>: 작품 완성 즉시 한국저작권위원회에 등록</li>
<li><strong>상표 출원</strong>: 브랜드명, 캐릭터명, 로고를 특허청에 출원</li>
<li><strong>계약서 표준화</strong>: 모든 협업에 표준 계약서 사용</li>
</ul>

<h2>2단계: 팬덤 설계 — 구매자가 아닌 커뮤니티를 만들어라</h2>
<p>일회성 구매자 1,000명보다 열렬한 팬 100명이 훨씬 강력한 비즈니스 자산입니다. 팬덤 설계는 단순히 SNS 팔로워를 늘리는 것이 아니라, 당신의 세계관에 진심으로 공감하는 사람들을 모으는 과정입니다.</p>
<p>아르트레너 파트너들의 데이터에 따르면, 팬덤이 탄탄한 아티스트는 그렇지 않은 아티스트에 비해 신제품 출시 시 초기 3일 판매량이 평균 <strong>14배</strong> 높았습니다.</p>

<h2>3단계: 수익 다각화 — 단일 수입원에 의존하지 마라</h2>
<p>성공한 아티스트-CEO들의 수입 구조는 보통 다음과 같습니다:</p>
<ul>
<li>디지털 콘텐츠 판매 (구독, 온라인 클래스): 40%</li>
<li>실물 상품 (굿즈, 아트프린트): 25%</li>
<li>브랜드 협업 및 라이선싱: 20%</li>
<li>오프라인 행사 및 강연: 15%</li>
</ul>
<p>단 하나의 수입원에 의존하는 것은 극도로 위험합니다. 플랫폼 알고리즘 하나가 바뀌면 수입 전체가 흔들릴 수 있기 때문입니다.</p>

<h2>4단계: 팀 구성 — 혼자 다 하려다 다 망한다</h2>
<p>아티스트가 가장 많이 하는 실수 중 하나가 모든 것을 혼자 하려는 것입니다. 창작, 마케팅, 정산, 고객 응대, 법무까지 혼자 감당하면 결국 창작의 질이 떨어지고 번아웃이 옵니다.</p>
<p>비즈니스 초기라면 최소한 <strong>운영·마케팅 담당자 1명</strong>과 함께 시작하는 것을 강력히 권장합니다. 아르트레너의 빌더팀이 바로 이 역할을 대신해드립니다.</p>

<h2>5단계: 스케일업 — 시스템으로 성장하라</h2>
<p>진정한 비즈니스는 아티스트가 없어도 돌아갈 수 있어야 합니다. 자동화된 판매 시스템, 체계화된 운영 프로세스, 데이터 기반 의사결정 구조를 갖추는 것이 스케일업의 핵심입니다.</p>
<p>아르트레너 파트너 중 이 5단계를 완성한 아티스트들의 평균 연 수익은 첫 해 대비 <strong>340% 성장</strong>했습니다.</p>

<h2>마치며</h2>
<p>이 5단계는 하루아침에 이루어지지 않습니다. 하지만 명확한 로드맵이 있다면 훨씬 빠르게 나아갈 수 있습니다. 아르트레너는 이 여정을 혼자 걷지 않아도 되도록 옆에서 함께합니다.</p>
    `,
  },
  {
    id: "2",
    slug: "creative-ip-100m-structure",
    category: "수익화",
    title: "창작 IP로 연 1억 버는 구조 만들기",
    excerpt: "팔로워 3만 명의 일러스트레이터가 12개월 만에 연 수익 1억을 달성한 실제 케이스. 수익 구조 설계의 A부터 Z까지.",
    coverImage: "https://readdy.ai/api/search-image?query=digital%20illustration%20artist%20earning%20money%20online%2C%20creative%20workspace%20with%20glowing%20screen%2C%20artwork%20displayed%2C%20financial%20growth%20concept%2C%20dark%20moody%20studio%20atmosphere%2C%20teal%20and%20purple%20neon%20accents&width=800&height=450&seq=blog-cover-02&orientation=landscape",
    author: blogAuthors.song,
    publishedAt: "2026-03-08",
    readTime: 10,
    tags: ["수익화", "일러스트레이터", "D2C", "구독모델"],
    content: `
<h2>케이스 스터디: 팔로워 3만 → 연 수익 1억</h2>
<p>2024년 아르트레너와 파트너십을 맺은 일러스트레이터 K씨는 인스타그램 팔로워 3만 명을 보유하고 있었지만 월 수익은 50만원 수준이었습니다. 12개월 후, K씨의 연 수익은 1억 2천만원을 돌파했습니다.</p>
<p>무엇이 바뀌었을까요?</p>

<h2>수익 구조 설계의 핵심: 깔때기를 만들어라</h2>
<p>대부분의 아티스트는 SNS에서 팔로워를 모으지만, 그 팔로워를 실제 수익으로 전환하는 '깔때기(funnel)'가 없습니다. K씨의 경우 다음과 같은 깔때기를 설계했습니다:</p>
<ol>
<li><strong>인식(Awareness)</strong>: 인스타그램 릴스로 매주 3개 콘텐츠 발행</li>
<li><strong>관심(Interest)</strong>: 뉴스레터 구독 유도 (무료 배경화면 증정)</li>
<li><strong>고려(Consideration)</strong>: 월 9,900원 멤버십 — 독점 일러스트 + 작업기 공개</li>
<li><strong>구매(Purchase)</strong>: 한정판 아트프린트, 굿즈 정기 드롭</li>
<li><strong>충성(Loyalty)</strong>: VIP 티어 — 커스텀 의뢰, 오프라인 드로잉 클래스</li>
</ol>

<h2>수익 항목별 실제 숫자</h2>
<p>12개월 차 K씨의 월 수익 분해:</p>
<ul>
<li>멤버십 구독자 820명 × 9,900원 = <strong>약 812만원</strong></li>
<li>굿즈 판매 (월 2회 드롭) = <strong>약 280만원</strong></li>
<li>브랜드 협업 (월 평균 1~2건) = <strong>약 200만원</strong></li>
<li>온라인 클래스 = <strong>약 110만원</strong></li>
</ul>
<p>합계: <strong>월 약 1,400만원 → 연 1억 6,800만원</strong></p>

<h2>구독 모델이 핵심인 이유</h2>
<p>단발성 판매에 의존하면 매달 '제로에서 시작'해야 합니다. 반면 구독 모델은 <strong>예측 가능한 월 기본 수익</strong>을 만들어줍니다. K씨의 경우 구독 수익만으로 월 800만원이 보장되어, 나머지 활동을 훨씬 여유롭게 기획할 수 있었습니다.</p>

<h2>플랫폼 선택 전략</h2>
<p>모든 플랫폼에 다 있을 필요 없습니다. K씨는 인스타그램(인식)과 자체 D2C 사이트(판매)에만 집중했습니다. 아르트레너가 구축한 D2C 플랫폼 덕분에 수수료 없이 100% 수익을 직접 가져갈 수 있었습니다.</p>
    `,
  },
  {
    id: "3",
    slug: "brand-collaboration-guide",
    category: "마케팅",
    title: "브랜드 협업 제안서 완벽 가이드: 거절당하지 않는 5가지 원칙",
    excerpt: "수백 건의 브랜드 협업을 성사시킨 아르트레너가 알려주는 제안서 작성법. 단 하나의 이메일로 대기업 협업을 따내는 전략.",
    coverImage: "https://readdy.ai/api/search-image?query=professional%20brand%20collaboration%20proposal%20document%20on%20elegant%20dark%20desk%2C%20luxury%20branding%20design%20elements%2C%20minimalist%20dark%20aesthetic%2C%20warm%20golden%20and%20orange%20accent%20lighting&width=800&height=450&seq=blog-cover-03&orientation=landscape",
    author: blogAuthors.jeong,
    publishedAt: "2026-03-01",
    readTime: 7,
    tags: ["브랜드 협업", "제안서", "마케팅", "B2B"],
    content: `
<h2>왜 대부분의 협업 제안은 무시당하는가</h2>
<p>아르트레너 디렉터로서 저는 매주 수십 건의 아티스트 협업 제안서를 검토합니다. 그리고 솔직히 말씀드리면, 그 중 80%는 첫 줄을 읽자마자 닫고 싶어집니다.</p>
<p>이유는 단순합니다. 대부분의 제안서가 <strong>아티스트 자신의 이야기</strong>만 하고 있기 때문입니다. 브랜드가 원하는 건 당신의 팔로워 숫자가 아닙니다. 브랜드가 원하는 건 <strong>자신들의 문제 해결</strong>입니다.</p>

<h2>원칙 1: 상대방의 언어로 말하라</h2>
<p>제안서의 첫 문단은 반드시 상대 브랜드에 대한 이야기로 시작해야 합니다. "귀사의 최근 MZ세대 마케팅 전략을 보며..." 또는 "귀 브랜드가 올해 집중하고 있는 지속가능성 캠페인과 관련하여..."</p>

<h2>원칙 2: 팔로워가 아닌 팬덤의 질을 보여줘라</h2>
<p>팔로워 10만보다 팬덤 1만이 훨씬 강력할 수 있습니다. 제안서에 포함해야 할 지표:</p>
<ul>
<li>저장률 (Save Rate): 5% 이상이면 최상위권</li>
<li>댓글 퀄리티: 단순 이모지가 아닌 문장형 댓글 비율</li>
<li>링크 클릭률: 스토리 링크 스와이프업 비율</li>
<li>구매 전환율: 이전 협업 사례가 있다면 반드시 포함</li>
</ul>

<h2>원칙 3: 숫자로 결과를 제시하라</h2>
<p>"좋은 콘텐츠를 만들어드리겠습니다"는 의미 없습니다. 구체적으로 제시하세요: "이번 캠페인을 통해 귀사 인스타그램 계정으로 최소 3,000명의 신규 팔로워 유입과 게시물 저장 1,000회 이상을 목표로 합니다."</p>

<h2>원칙 4: 선택지를 3가지로 제한하라</h2>
<p>옵션이 너무 많으면 결정 장애가 생깁니다. 협업 패키지는 3가지만 — 베이직, 스탠다드, 프리미엄. 각각 명확한 딜리버러블과 금액을 제시하세요.</p>

<h2>원칙 5: 마감일을 설정하라</h2>
<p>제안서 끝에 반드시 "이 제안은 4월 30일까지 유효합니다"와 같이 마감일을 명시하세요. 인위적 희소성이 결정을 앞당깁니다.</p>
    `,
  },
  {
    id: "4",
    slug: "artist-tax-and-legal-guide",
    category: "법무·세금",
    title: "아티스트를 위한 세금과 법인 설립 완벽 가이드 2026",
    excerpt: "프리랜서로 활동하다 세금 폭탄 맞은 아티스트라면 필독. 언제 법인을 세워야 하는지, 어떤 세금을 내야 하는지 직접 설명합니다.",
    coverImage: "https://readdy.ai/api/search-image?query=tax%20documents%20and%20legal%20papers%20on%20elegant%20dark%20desk%20with%20artistic%20elements%2C%20professional%20financial%20planning%20scene%2C%20dark%20moody%20lighting%20with%20purple%20and%20white%20accents%2C%20minimalist%20aesthetic&width=800&height=450&seq=blog-cover-04&orientation=landscape",
    author: blogAuthors.song,
    publishedAt: "2026-02-22",
    readTime: 12,
    tags: ["세금", "법인설립", "프리랜서", "법무"],
    content: `
<h2>아티스트에게 세금이 특히 복잡한 이유</h2>
<p>일반 직장인은 회사가 세금을 알아서 처리해줍니다. 하지만 아티스트는 다릅니다. 브랜드 협업 수입, 플랫폼 수익, 오프라인 판매, 강연료 등 소득 유형이 다양하고 각각 과세 방식이 다릅니다.</p>

<h2>연 수익 구간별 최적 과세 구조</h2>
<h3>연 수익 3,000만원 미만: 프리랜서(종합소득세)</h3>
<p>이 구간에서는 굳이 법인을 설립할 필요 없습니다. 간편 장부 기장으로 충분하며, 청년 창업 세액 공제 등 개인 공제 혜택을 최대한 활용하세요.</p>

<h3>연 수익 3,000만원 ~ 1억원: 개인사업자 등록 고려</h3>
<p>이 구간부터는 부가가치세 관리가 필요합니다. 또한 차량, 장비, 작업공간 등 업무 관련 지출을 비용 처리할 수 있어 절세 효과가 큽니다. 일반과세자 등록을 권장합니다.</p>

<h3>연 수익 1억원 이상: 법인 전환 검토</h3>
<p>개인 소득세 최고세율은 45%입니다. 반면 법인세는 매출 규모에 따라 9~24%로 훨씬 낮습니다. 연 수익 1억 이상이라면 법인 전환을 통해 절세액이 수천만원에 달할 수 있습니다.</p>

<h2>아티스트가 놓치는 주요 공제 항목</h2>
<ul>
<li><strong>장비 및 소프트웨어</strong>: 태블릿, 카메라, 포토샵 구독 등 전액 비용 처리</li>
<li><strong>작업공간</strong>: 집에서 작업하는 경우 주거비의 일부 공제 가능</li>
<li><strong>교육비</strong>: 직무 관련 강의, 워크숍 수강료</li>
<li><strong>네트워킹</strong>: 업무 관련 식비, 교통비</li>
<li><strong>해외 출장</strong>: 전시, 페어 참가 관련 비용</li>
</ul>

<h2>법인 설립 시 주의사항</h2>
<p>법인 설립 자체는 어렵지 않습니다. 문제는 설립 후 운영입니다. 법인 통장과 개인 통장을 반드시 분리하고, 모든 비용에 대해 증빙 서류를 보관해야 합니다. 세무사 선임은 선택이 아닌 필수입니다.</p>

<h2>아르트레너 법무팀의 도움을 받을 수 있는 부분</h2>
<p>아르트레너 파트너에게는 법무팀의 무제한 세무·법무 자문이 포함됩니다. 법인 설립부터 계약서 검토, 분쟁 해결까지 전 과정을 지원합니다.</p>
    `,
  },
  {
    id: "5",
    slug: "fandom-to-revenue-d2c",
    category: "수익화",
    title: "팬덤을 수익으로: D2C 비즈니스의 모든 것",
    excerpt: "플랫폼 수수료 0%, 팬과 직접 연결. D2C(Direct to Consumer) 전략으로 수익을 극대화하는 방법을 단계별로 알려드립니다.",
    coverImage: "https://readdy.ai/api/search-image?query=fan%20community%20digital%20connection%20dark%20background%2C%20creator%20economy%20concept%2C%20glowing%20devices%20with%20art%20content%2C%20teal%20neon%20accents%2C%20minimalist%20dark%20aesthetic%2C%20direct%20to%20consumer%20concept&width=800&height=450&seq=blog-cover-05&orientation=landscape",
    author: blogAuthors.jeong,
    publishedAt: "2026-02-15",
    readTime: 9,
    tags: ["D2C", "팬덤", "이커머스", "수익화"],
    content: `
<h2>D2C란 무엇인가</h2>
<p>D2C(Direct to Consumer)는 중간 유통 플랫폼 없이 아티스트가 팬에게 직접 판매하는 구조입니다. 네이버 스마트스토어나 인스타그램 쇼핑을 통해 판매하면 수수료가 발생하지만, D2C 자체 쇼핑몰을 운영하면 수익의 100%가 아티스트에게 돌아갑니다.</p>

<h2>D2C의 진짜 강점: 데이터 소유</h2>
<p>플랫폼에서 판매하면 고객 데이터는 플랫폼이 가집니다. 내 팬이 누구인지, 무엇을 좋아하는지, 언제 구매하는지를 내가 모릅니다. D2C는 이 모든 데이터를 아티스트가 직접 소유합니다.</p>
<p>데이터를 소유하면:</p>
<ul>
<li>개인화된 이메일 마케팅 가능</li>
<li>재구매율 분석 및 개선</li>
<li>신제품 수요 예측</li>
<li>세분화된 팬층별 맞춤 제안</li>
</ul>

<h2>아르트레너 D2C 플랫폼의 차별점</h2>
<p>아르트레너는 파트너 아티스트에게 완전히 커스터마이징된 D2C 플랫폼을 구축해드립니다. 일반 쇼핑몰과의 차이점:</p>
<ul>
<li><strong>멤버십 연동</strong>: 구독자 전용 가격, 얼리버드 접근권 자동 처리</li>
<li><strong>한정판 드롭 시스템</strong>: 카운트다운, 재고 실시간 표시로 FOMO 극대화</li>
<li><strong>팬 CRM</strong>: 구매 이력 기반 팬 등급 자동 분류</li>
<li><strong>자동 정산</strong>: 수수료, 세금 자동 계산 및 정산</li>
</ul>

<h2>D2C 시작하기 전 체크리스트</h2>
<p>✓ 뉴스레터 구독자 최소 500명 확보<br/>
✓ 인스타그램 저장률 3% 이상<br/>
✓ 판매할 첫 상품 최소 3가지 준비<br/>
✓ 결제 시스템 및 배송 프로세스 구축<br/>
✓ 고객 서비스 응대 프로세스 설계</p>
    `,
  },
  {
    id: "6",
    slug: "success-case-illustrator",
    category: "성공 사례",
    title: "케이스 스터디: 취미 그림쟁이에서 연 2억 크리에이터로",
    excerpt: "직장을 다니며 취미로 그림을 그리던 이진아 씨. 아르트레너와 파트너십을 맺고 18개월 만에 전업 크리에이터로 독립했습니다.",
    coverImage: "https://readdy.ai/api/search-image?query=successful%20korean%20female%20illustrator%20artist%20in%20creative%20studio%20surrounded%20by%20colorful%20artwork%2C%20inspired%20and%20joyful%20expression%2C%20dark%20moody%20background%20with%20orange%20and%20purple%20accent%20lighting%2C%20success%20story%20concept&width=800&height=450&seq=blog-cover-06&orientation=landscape",
    author: blogAuthors.song,
    publishedAt: "2026-02-08",
    readTime: 6,
    tags: ["성공 사례", "일러스트레이터", "전업 크리에이터", "파트너"],
    content: `
<h2>시작: 퇴근 후 그림 그리는 직장인</h2>
<p>이진아 씨(32세)는 IT 기업에 다니는 평범한 직장인이었습니다. 퇴근 후에는 인스타그램에 일상적인 감성 일러스트를 올렸고, 3년 만에 팔로워는 4만 2천명이 됐습니다. 하지만 수익은 가끔 들어오는 협업 제안 몇 건이 전부였습니다.</p>
<p>2024년 6월, 이진아 씨는 아르트레너에 진단 신청을 했습니다.</p>

<h2>진단 결과: 강점과 gap</h2>
<p>아르트레너 빌더팀이 분석한 이진아 씨의 강점:</p>
<ul>
<li>팬덤의 질이 매우 높음 (댓글 문장 비율 78%, 저장률 6.2%)</li>
<li>독특한 세계관 — "도시 감성" 일러스트는 2030 직장인의 공감을 극도로 자극</li>
<li>꾸준한 발행 습관 (3년간 주 3회 업로드 무결)</li>
</ul>
<p>그러나 치명적인 gap:</p>
<ul>
<li>수익화 구조 전무 — 플랫폼 수수료 30~40% 떼는 외부 마켓 의존</li>
<li>팬 데이터 소유 없음</li>
<li>상품 라인업 부재</li>
</ul>

<h2>6개월 빌딩 과정</h2>
<p><strong>1~2개월</strong>: D2C 플랫폼 구축 + 뉴스레터 론칭 (무료 배경화면 증정 → 2개월 만에 구독자 8,200명)</p>
<p><strong>3~4개월</strong>: 멤버십 론칭 (월 12,900원, 독점 일러스트 + 작업기 + 할인 코드) → 론칭 1주일 만에 1,100명 가입</p>
<p><strong>5~6개월</strong>: 첫 한정판 굿즈 드롭 (아트프린트 300장 + 노트 500개) → 오픈 2시간 만에 완판, 매출 2,800만원</p>

<h2>18개월 후: 전업 크리에이터 독립</h2>
<p>18개월 차 이진아 씨의 월 수익:</p>
<ul>
<li>멤버십 (1,840명 × 12,900원): 약 2,374만원</li>
<li>분기별 굿즈 드롭: 월 평균 700만원</li>
<li>브랜드 협업: 월 400만원</li>
</ul>
<p><strong>합계: 월 약 3,500만원 → 연 4억 2천만원</strong></p>
<p>이진아 씨는 2025년 12월, 다니던 직장에 사직서를 제출했습니다.</p>

<blockquote>
<p>"솔직히 이렇게 빨리 될 줄 몰랐어요. 빌더팀이 제가 몰랐던 것들을 너무 명확하게 알려줬고, 저는 그냥 그림만 그렸는데 나머지가 돌아가더라고요."</p>
<p>— 이진아, 아르트레너 파트너 (아티스트명: JINA.ill)</p>
</blockquote>
    `,
  },
  {
    id: "7",
    slug: "7-mistakes-art-startup",
    category: "비즈니스 전략",
    title: "문화예술 창업에서 가장 많이 하는 실수 7가지",
    excerpt: "3년간 200명의 아티스트를 관찰하며 발견한 공통적인 실수 패턴. 이것만 피해도 성공 확률이 3배는 높아집니다.",
    coverImage: "https://readdy.ai/api/search-image?query=artist%20making%20mistakes%20concept%2C%20frustrated%20creative%20person%20in%20dark%20studio%2C%20lesson%20learning%2C%20dark%20moody%20purple%20and%20orange%20lighting%2C%20minimalist%20aesthetic%2C%20conceptual%20business%20failure%20and%20recovery&width=800&height=450&seq=blog-cover-07&orientation=landscape",
    author: blogAuthors.jeong,
    publishedAt: "2026-01-25",
    readTime: 7,
    tags: ["창업", "실수", "비즈니스 전략", "아티스트"],
    content: `
<h2>실수 1: 완벽한 작품을 만들려다 아무것도 내놓지 못한다</h2>
<p>많은 아티스트들이 "아직 준비가 안 됐어"라며 수개월, 심지어 수년을 준비만 합니다. 하지만 시장은 완벽한 것보다 지금 당장 쓸 수 있는 것을 원합니다. MVP(최소 실행 가능 제품) 개념을 반드시 도입하세요.</p>

<h2>실수 2: 가격을 너무 낮게 책정한다</h2>
<p>아티스트들이 가장 많이 하는 실수 중 하나입니다. "이게 팔릴까?"라는 불안감에 터무니없이 낮은 가격을 책정합니다. 낮은 가격은 작품의 가치를 스스로 낮추는 행위입니다. 또한 저가 고객을 모으면 나중에 가격을 올리기 극도로 어려워집니다.</p>

<h2>실수 3: SNS 팔로워 = 수익이라고 착각한다</h2>
<p>팔로워 10만명이 넘어도 월 수익이 100만원도 안 되는 아티스트가 수두룩합니다. 팔로워는 잠재 고객일 뿐입니다. 팔로워를 수익으로 전환하는 '깔때기'가 없으면 팔로워는 그냥 숫자일 뿐입니다.</p>

<h2>실수 4: 계약서 없이 협업한다</h2>
<p>계약서 없이 진행한 협업에서 대가를 받지 못하거나, 작품 저작권을 빼앗기는 사례가 매년 수백 건 발생합니다. 이메일이나 카카오톡 메시지도 법적 효력이 있지만, 명확한 계약서를 갖추는 것이 최선입니다.</p>

<h2>실수 5: 모든 플랫폼에 다 있으려 한다</h2>
<p>인스타그램, 틱톡, 유튜브, 트위터, 스레드, 블로그... 모든 채널을 관리하려다 번아웃이 옵니다. 시작 단계에서는 1~2개 플랫폼에 집중하고, 거기서 완전히 자리를 잡은 후 확장하세요.</p>

<h2>실수 6: 커뮤니티가 아닌 팔로워를 모은다</h2>
<p>팔로우 버튼을 누르는 것은 아무 비용도 들지 않습니다. 하지만 이메일 주소를 남기거나 유료 멤버십에 가입하는 것은 진짜 참여(engagement)입니다. 진짜 팬을 모으는 것에 집중하세요.</p>

<h2>실수 7: 혼자 다 하려 한다</h2>
<p>창작, 마케팅, 운영, 고객 응대, 세금, 법무... 아티스트가 이 모든 것을 혼자 하는 것은 물리적으로 불가능합니다. 빠른 시일 내에 팀을 구성하거나, 아르트레너처럼 이 모든 것을 대신해줄 파트너를 찾아야 합니다.</p>
    `,
  },
  {
    id: "8",
    slug: "nft-vs-membership",
    category: "수익화",
    title: "NFT vs 멤버십: 아티스트에게 맞는 수익화 모델 고르기",
    excerpt: "NFT 붐이 지나간 지금, 어떤 디지털 수익화 전략이 실제로 작동하는가. 각 모델의 장단점을 데이터로 비교합니다.",
    coverImage: "https://readdy.ai/api/search-image?query=digital%20art%20NFT%20versus%20membership%20subscription%20concept%2C%20glowing%20blockchain%20and%20subscription%20interface%20on%20dark%20background%2C%20teal%20and%20orange%20accent%20colors%2C%20futuristic%20minimalist%20design&width=800&height=450&seq=blog-cover-08&orientation=landscape",
    author: blogAuthors.song,
    publishedAt: "2026-01-18",
    readTime: 8,
    tags: ["NFT", "멤버십", "디지털 수익화", "크리에이터 이코노미"],
    content: `
<h2>NFT의 현재 위치</h2>
<p>2021~2022년의 NFT 광풍은 사실상 끝났습니다. 그렇다고 NFT가 완전히 죽은 것은 아닙니다. 다만 "모든 것을 NFT로"라는 환상은 걷혔고, 실질적 유틸리티가 있는 NFT만 살아남았습니다.</p>

<h2>NFT가 여전히 유효한 경우</h2>
<ul>
<li>작품의 희소성과 진품 증명이 핵심 가치일 때</li>
<li>국제 팬층이 있고 글로벌 결제가 필요할 때</li>
<li>커뮤니티 멤버십 토큰으로 활용할 때</li>
</ul>
<p>단, NFT 민팅과 판매에는 상당한 기술적 진입 장벽과 가스비 부담이 있습니다. 아직 팬덤이 형성되지 않은 초기 아티스트에게는 권장하지 않습니다.</p>

<h2>멤버십 모델의 압도적 장점</h2>
<p>아르트레너 파트너 데이터 기준, 멤버십 수익이 전체 수익의 40% 이상을 차지하는 아티스트의 평균 연 수익은 그렇지 않은 아티스트보다 <strong>2.8배 높습니다</strong>.</p>
<p>멤버십의 핵심 장점:</p>
<ul>
<li><strong>예측 가능성</strong>: 매달 기본 수익 보장</li>
<li><strong>낮은 기술 장벽</strong>: 누구나 쉽게 시작 가능</li>
<li><strong>팬 결속력 강화</strong>: 구독자는 단순 팔로워보다 훨씬 강한 유대감 형성</li>
<li><strong>데이터 수집</strong>: 구독자 데이터 직접 보유</li>
</ul>

<h2>하이브리드 전략: 둘 다 쓰는 법</h2>
<p>일부 아티스트들은 멤버십의 안정성 + NFT의 희소성을 결합한 하이브리드 전략을 씁니다. 예를 들어:</p>
<ul>
<li>월 구독자에게 한정 NFT 민팅 우선권 제공</li>
<li>구독 등급별 NFT 에어드롭</li>
<li>NFT 홀더에게 영구 VIP 멤버십 자격 부여</li>
</ul>

<h2>결론: 지금 당장 시작한다면?</h2>
<p>팬덤 형성 초기라면 멤버십에 집중하세요. NFT는 팬덤이 충분히 형성된 후 고려하세요. 명확한 유틸리티 없는 NFT는 2026년 현재 팔리지 않습니다.</p>
    `,
  },
  {
    id: "9",
    slug: "sns-10k-followers-revenue",
    category: "마케팅",
    title: "SNS 팔로워 1만명으로 월 500만원 만들기: 실전 공식",
    excerpt: "팔로워 숫자가 전부가 아닙니다. 팔로워 1만명으로도 충분히 월 500만원 이상 수익을 낼 수 있습니다. 검증된 공식을 공개합니다.",
    coverImage: "https://readdy.ai/api/search-image?query=social%20media%20content%20creator%20with%20small%20but%20engaged%20following%20making%20money%2C%20dark%20moody%20studio%20with%20phone%20screens%20showing%20follower%20count%20and%20revenue%2C%20purple%20and%20orange%20accent%20lighting%2C%20creator%20economy%20concept&width=800&height=450&seq=blog-cover-09&orientation=landscape",
    author: blogAuthors.jeong,
    publishedAt: "2026-01-10",
    readTime: 6,
    tags: ["SNS", "팔로워", "마이크로 인플루언서", "수익화"],
    content: `
<h2>팔로워 1만 = 충분한 시장</h2>
<p>많은 아티스트들이 팔로워가 10만, 100만 되어야 돈을 벌 수 있다고 생각합니다. 완전히 잘못된 생각입니다. 팔로워 1만명 중 2%만 월 25,000원짜리 멤버십에 가입해도 월 500만원입니다.</p>

<h2>공식: 팔로워 1만으로 500만원 만드는 방법</h2>
<h3>Step 1: 팔로워를 이메일 구독자로 전환</h3>
<p>팔로워 1만 → 이메일 구독자 1,000명 확보 (전환율 10% 목표)</p>
<p>무료 리드 마그넷: 독점 배경화면, 무료 강의 1강, 프리셋 팩 등</p>

<h3>Step 2: 멤버십 구조 설계</h3>
<ul>
<li>베이직 티어: 월 9,900원 (독점 콘텐츠 월 2회)</li>
<li>스탠다드 티어: 월 19,900원 (독점 콘텐츠 + 작업 과정 영상)</li>
<li>프리미엄 티어: 월 49,900원 (위 모두 + 월 1회 1:1 피드백)</li>
</ul>

<h3>Step 3: 월 500만원 도달 경로</h3>
<p>이메일 구독자 1,000명 중 멤버십 전환율 20% 기준:</p>
<ul>
<li>베이직 100명 × 9,900원 = 990,000원</li>
<li>스탠다드 70명 × 19,900원 = 1,393,000원</li>
<li>프리미엄 30명 × 49,900원 = 1,497,000원</li>
</ul>
<p>합계: 약 3,880,000원</p>
<p>여기에 분기별 굿즈 드롭 1~2회 추가하면 월 평균 500만원 달성은 충분히 가능합니다.</p>

<h2>전제 조건: 팔로워의 질이 핵심</h2>
<p>이 공식이 작동하려면 팔로워가 <strong>진짜 당신의 팬</strong>이어야 합니다. 이벤트로 모은 팔로워, 맞팔로 모은 팔로워는 멤버십 전환율이 1% 미만입니다. 팔로워 수에 집착하지 말고 팬덤의 질에 집중하세요.</p>
    `,
  },
];

export const blogCategories = ["전체", "비즈니스 전략", "수익화", "마케팅", "법무·세금", "성공 사례"];
